import $ from 'jquery'

export default {
    name: 'demande-annulation',
    components: {},
    props: {
        operations_tobe_canceled: Array,
        user_id: Number,
        compte_id: Number,
        demand_toggler: Number,
        current_date_filter: Object
    },
    data() {
        return {
            fields: [
                { key: 'ref', label: 'Référence' }, { key: 'libelle', label: 'Libellé' },
                "patient", { key: 'montant', label: 'Montant' }, { key: 'client_rembourse', label: 'Client remboursé' }, 
                { key: 'retour_stock', label: 'Retour stock' }
            ],
            perPage: -1,
            currentPage: 1,

            remboursement_client: [],
            is_justif: false,
            justification: '',
            justif_is_empty: false,
            is_confirm: false,
            save_loading: false
        }
    },

    watch: {
        demand_toggler() {
            this.setConditionDemandeAnnulation()
        }
    },

    computed: {

    },

    mounted() {
        
    },

    methods: {
        toggleRemboursement(index, value) {
            this.operations_tobe_canceled[index].est_rembourse = value
        },

        toggleRetorStock(index, value) {
            this.operations_tobe_canceled[index].retour_stock = value
        },

        setConditionDemandeAnnulation() {
            let i = 0
            this.operations_tobe_canceled.forEach((operation) => {
                this.operations_tobe_canceled[i].est_rembourse = 0
                this.operations_tobe_canceled[i].retour_stock = (operation.data_type == 'consommable_bon')?1:null

                i++
            });
        },

        toggleJustif() {
            this.is_justif = !this.is_justif
        },

        submit(selector) {
            if (this.justification == '') {
                this.justif_is_empty = true
                return
            }

            if (!this.is_confirm) {
                this.is_confirm = true
                return
            }

            const confirm = document.getElementById(selector);
            if (!confirm.checked) { 
                $('.err-msg').fadeIn(500)
                return
            }

            this.save_loading = true

            const data = {
                user_id: this.user_id,
                compte_id: this.compte_id,
                operations: this.operations_tobe_canceled,
                justification: this.justification
            }
            this.$store.dispatch('storeDemandeAnnulation', data).then((response) => {
                if (response.success) {

                    this.$emit('emitOperationCaisse', this.current_date_filter)
                    this.justification = ''
                    this.is_justif = false
                    this.$refs.cancellation.click()
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        },

        clearError() {
            this.justif_is_empty = false
            $('.err-msg').fadeOut(500);
        },

        onConfirm() {
            this.clearError()
        },
    }
}